import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import {
  selectTerritoryId,
  updateVoiceConfig as updateVoiceConfigAction,
} from '@/features/domain/territory'
import { useIsUnmounted, useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

import { VoiceFormValues } from '../../typings'
import { getFormValues } from './getFormValues'

export function useOnSubmit(clearEditingState: () => void) {
  const isUnMounted = useIsUnmounted()
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const territoryId = useSelector(selectTerritoryId)

  return useCallback(
    async (formValues: VoiceFormValues) => {
      try {
        const voice = getFormValues(formValues)
        const thunkResult = await dispatch(
          updateVoiceConfigAction({ voiceConfig: voice, territoryId }),
        )

        if (updateVoiceConfigAction.rejected.match(thunkResult)) {
          throw new Error(thunkResult.payload?.message ?? 'Internal error')
        }

        if (isUnMounted()) return

        clearEditingState()
      } catch (e) {
        toast.error(e.message)
      }
    },
    [clearEditingState, dispatch, isUnMounted, toast],
  )
}
